import { Link, useNavigate } from 'react-router-dom';
import FixedLines from '../components/common/FixedLines';
import UiIcon from '../components/common/UiIcon';
import { SITE_CONFIG } from '../config/site';

const notFoundHeadingLines = ['찾으시는 페이지를', '불러오지 못했습니다.'];

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#140f0d] text-[#f7efe2]">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,#140f0d_0%,#17110e_45%,#120d0b_100%)]" />
      <div className="pointer-events-none absolute inset-0 bg-grain opacity-[0.07]" />

      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-6xl flex-col px-6 py-8 sm:px-8 lg:pl-6 lg:pr-28 xl:pr-32">
        <header className="flex items-center justify-between">
          <Link
            to="/"
            aria-label="메인 페이지로 이동"
            className="flex flex-col transition-colors hover:text-white focus:outline-none focus:ring-2 focus:ring-[#fbbf24]/60 focus:ring-offset-2 focus:ring-offset-[#140f0d]"
          >
            <span className="text-[11px] uppercase tracking-[0.32em] text-[#ebd6bc]/82">
              {SITE_CONFIG.serviceNameEn}
            </span>
            <span className="mt-2 text-[10px] uppercase tracking-[0.22em] text-[#c4a289]/55">
              Lost Page
            </span>
          </Link>
        </header>

        <main className="flex flex-1 items-center justify-center py-12">
          <section className="mx-auto grid w-full max-w-[60rem] items-center gap-10 lg:grid-cols-[minmax(0,1.08fr)_minmax(0,0.78fr)] lg:gap-8">
            <div className="relative">
              <div className="relative overflow-hidden border border-[#7a5317]/70 bg-[#18120f]/88 px-8 py-10 shadow-[0_40px_120px_-52px_rgba(0,0,0,0.9)] sm:px-10 sm:py-12">
                <div className="absolute inset-0 border border-white/[0.04]" />
                <div className="relative">
                  <p className="text-[12px] uppercase tracking-[0.28em] text-[#f0c176]/70">404 Error</p>
                  <div
                    className="mt-4 text-[6.4rem] font-black italic leading-none text-[#fbf3e8] sm:text-[7.8rem] lg:text-[9rem]"
                    style={{ fontFamily: 'Hahmlet, serif' }}
                  >
                    404
                  </div>
                  <p className="mt-4 max-w-sm text-sm leading-7 text-[#ead6bd]/78 sm:text-[15px]">
                    문 앞에서 길을 놓친 밤입니다. 찾으시는 페이지가 사라졌거나, 주소가 살짝
                    어긋난 것 같아요.
                  </p>
                </div>
              </div>
            </div>

            <div className="max-w-[26rem] lg:justify-self-start">
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#f0c176]/75">문이 닫힌 밤</p>
              <FixedLines
                lines={notFoundHeadingLines}
                as="h1"
                className="mt-5 w-fit font-serif text-[2.08rem] font-extrabold leading-[1.02] tracking-[-0.04em] text-[#fbf3e8] sm:text-[3.15rem] lg:text-[3.35rem] xl:text-[4rem]"
                lineClassName="inline-block w-max whitespace-nowrap"
              />
              <p className="mt-6 max-w-xl text-[15px] leading-8 text-[#ead6bd]/88 sm:text-base">
                메인으로 돌아가 다시 시작해도 되고, 바로 전 페이지로 돌아가도 됩니다.
                리딩 흐름은 거기서 다시 이어갈 수 있어요.
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <button
                  type="button"
                  onClick={() => navigate('/')}
                  className="inline-flex items-center justify-center gap-3 rounded-lg border border-[#bd3b0f]/55 bg-[#bd3b0f] px-6 py-4 text-sm font-semibold tracking-[0.18em] text-[#fff3df] transition-colors hover:border-[#d65a2a] hover:bg-[#9f3210]"
                >
                  <UiIcon name="home" className="h-4 w-4" />
                  메인으로 돌아가기
                </button>
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="inline-flex items-center justify-center gap-2 rounded-lg border border-[#8a6a4b]/55 bg-[#18120f]/75 px-6 py-4 text-sm tracking-[0.16em] text-[#e8d1b7] transition-colors hover:bg-[#241914]"
                >
                  <UiIcon name="arrow-left" className="h-4 w-4" />
                  이전 페이지
                </button>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}
